import { actions as exportActions } from 'actions/exportToCsvActions';
import { connect } from 'react-redux';
import RoomSystems from 'components/RoomSystems/RoomSystems';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch: Function) => ({
  resetExportState: () => {
    dispatch(exportActions.fetchCsvDataReset());
  },
});

export default
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(RoomSystems);
